import React, { useState } from 'react';
import { Button, Tooltip, Snackbar, Alert } from '@mui/material';
import GavelIcon from '@mui/icons-material/Gavel';

// Public insolvency registry (Registro Público Concursal). Its search form is
// captcha-protected, so we can't query it automatically. This button runs
// entirely on the client: it copies the client's DNI to the clipboard and
// opens the official consultation page in a new tab, so the agent pastes the
// DNI, solves the captcha and reads whether there's a record.
const RPC_URL = 'https://www.publicidadconcursal.es/consulta-publicidad-concursal-new';

const PublicidadConcursalButton = ({ dni }) => {
  const [snack, setSnack] = useState(false);
  const cleanDni = String(dni || '').trim();

  const handleClick = async () => {
    try {
      if (cleanDni && navigator.clipboard) {
        await navigator.clipboard.writeText(cleanDni);
      }
    } catch (e) {
      // clipboard may be blocked; opening the page is the important part
    }
    setSnack(true);
    window.open(RPC_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <Tooltip
        title={
          cleanDni
            ? `Copia el DNI ${cleanDni} y abre el Registro Público Concursal`
            : 'Este caso no tiene DNI'
        }
      >
        <span>
          <Button
            variant="contained"
            startIcon={<GavelIcon />}
            onClick={handleClick}
            disabled={!cleanDni}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: 2,
              backgroundColor: '#6d4c41',
              '&:hover': { backgroundColor: '#5d4037' },
            }}
          >
            Consultar Registro Concursal
          </Button>
        </span>
      </Tooltip>
      <Snackbar
        open={snack}
        autoHideDuration={5000}
        onClose={() => setSnack(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity="info" onClose={() => setSnack(false)} sx={{ width: '100%' }}>
          DNI <strong>{cleanDni}</strong> copiado — pégalo en el buscador del Registro Concursal.
        </Alert>
      </Snackbar>
    </>
  );
};

export default PublicidadConcursalButton;
